module.exports = __webpack_public_path__ + "img/badge_conversione_premio.18680695.jpg";